export default "__VITE_ASSET__6X7owbxz__"